

import {
    init,
    select,
    SelectList,
    add,
} from 'one-state-core';

import {
    SET,
    SETSELECTED,
    SETPATIENTSELECTED,
    RESET,
    ADD
} from './types';

import {
    Actions,
} from './actions';

import {
    Subject
} from './Subject';

export const subjectstate = (
    context: any,
    initial?: SelectList<Subject>,
) => {
    const initValue = initial || {
        values: undefined,
    };

    return (
        state: SelectList<Subject> = initValue,
        action: Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state || initValue;
        // Values been assigned to empty array for patient global search
        // Fuctionality.
        if(type === ADD && updated.values === undefined){
            updated.values = [];
        }
        //Below condition if applicabe for if a caller is provider scenario
        //To achieve the NO Data fucntionality
        if(type === 'caller-provider' && updated.values === undefined){
            updated.values = [];
            updated.selected = undefined;
        }
        switch (type) {
            case SET:
                updated = init<Subject>(
                    updated,
                    payload as Subject[],
                );
                break;

            case RESET:
                updated = {
                    values: undefined,
                };
                break;

            case SETPATIENTSELECTED:
                updated = select<Subject>(
                    updated,
                    (source) => (
                        source.id === payload.id
                    ),
                );
                break;

            case SETSELECTED:
                updated = select<Subject>(
                    updated,
                    (source) => (
                        source.id === payload.id
                    ),
                );
                break;
            case ADD:
                updated = add<Subject>(
                    updated,
                    payload as Subject,
                );
                break;
        }
        return updated;
    }
};
